'use client'

import React, { FC, ReactElement } from 'react'
import { Button } from '@/components/ui/button'
import { Search } from 'lucide-react'
import useSearchCollections from '@/utils/hooks/useSearchCollections'

import CommandPalette, { CommandPaletteHandle } from './palette'

/// The header's search box: a button trigger plus the shared command palette
/// (./palette.tsx). The palette gates its bus/keyboard listeners on this
/// button's visibility — one SearchInput mounts per header breakpoint, and
/// only the visible one may answer a `command` event.
const SearchInput: FC<{
	className?: string
	inputRootClassName?: string
	inputClassName?: string
	onSubmit?: () => void
	enableDropdown?: boolean
	startAdornment?: ReactElement
	startAdornmentClassName?: string
	dropDownClassName?: string
	backgroundClassName?: string
}> = (_props): ReactElement => {
	// Warm the existing ranking feed after initial rendering, before the dialog opens.
	const [warmSearch, setWarmSearch] = React.useState(false)
	useSearchCollections(warmSearch)
	React.useEffect(() => {
		const timer = window.setTimeout(() => setWarmSearch(true), 1000)
		return () => window.clearTimeout(timer)
	}, [])
	const buttonRef = React.useRef<HTMLButtonElement | null>(null)
	const paletteRef = React.useRef<CommandPaletteHandle | null>(null)

	return (
		<>
			<Button
				ref={buttonRef}
				variant="outline"
				className="w-full rounded-sm text-sm font-normal flex justify-between"
				onClick={() => paletteRef.current?.open()}
			>
				<div className="flex items-center">
					<Search className="mr-2 size-4" />
					Search
				</div>
				<kbd className="ml-4 pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
					<span className="text-xs">/</span>
				</kbd>
			</Button>
			<CommandPalette ref={paletteRef} triggerRef={buttonRef} />
		</>
	)
}

export default SearchInput
